import { render, staticRenderFns } from "./ReferredFriend.vue?vue&type=template&id=4d0669be&scoped=true"
import script from "./ReferredFriend.vue?vue&type=script&lang=js"
export * from "./ReferredFriend.vue?vue&type=script&lang=js"
import style0 from "./ReferredFriend.vue?vue&type=style&index=0&id=4d0669be&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0669be",
  null
  
)

export default component.exports